/*------------------------------------------------------------------------------------------------------------------
about：支持连接的设备的控制。
- model 号：后端人员提供，比较全
- 设备类型号码：从 http://wiki.orvibo.com:8190/pages/viewpage.action?pageId=24608913 查阅
author：马兆铿
date：2017-11-16
* -----------------------------------------------------------------------------------------------------------------*/
import {kookongDeviceType} from "./set/remote";

//支持入网的设备类型号
const connectDeviceType = {
  XIAO_FANG: 30,
  ALL_ONE_PRO: 67,
  S30c: 29,
  S20c: 29,
  WIFI_LED_STRIP: 116,
  TV: 6,
  AIR: 5,
  TV_BOX: 32,
  FAN: 58,
  ZIGBEE_MINI: 45,
  ZIGBEE_CURTAIN_MOTO: 68,
};

/*  前端支持入网的设备信息
 * 酷控设备类型： 1（机顶盒）;2（电视机）;3（电视盒子）;4; 5（空调）; 6（投影仪）;7（音响）;    8（风扇）
 * 传输时需要转换下
 * */
export const supportConnectDevice = [
  /*--------------------------- wifi类 ---------------------------*/
  {
    name: 'xiaoyuan',
    chName: '小圆智能遥控器',
    deviceType: connectDeviceType.XIAO_FANG, //后台的设备号
    deviceGeneralType: 'controller_wifi', //前端定义的设备大类
    connectType: 'wifi',
    functionType: 'controller', //功能类型：控制器
    isHaveDeviceBelow: true, //可以添加设备
    link: '/device/xiaofang', //对应设备首页
    model: [
      "f4b5e79d9219447ebf610d7c3067ae57",
      "d7d0cc45682b4f8797f8af13932b75ba"
    ]
  },
  {
    name: 'xiaofang',
    chName: '小方智能遥控器',
    deviceType: connectDeviceType.XIAO_FANG, //后台的设备号
    deviceGeneralType: 'controller_wifi', //前端定义的设备大类
    connectType: 'wifi',
    functionType: 'controller', //功能类型：控制器
    isHaveDeviceBelow: true, //可以添加设备
    link: '/device/xiaofang', //对应设备首页
    model: [
      "ffd65d82eae248a8a8bc08a2cb688a2b",
      "b20d750dd2a340539db6790b2feb9bc4",
      "5005c109381046a895528e48de343d3b",
      "6aed061587f04620a17e057eeeb3c695",
      "d9e0292225204596aa57cd216a16af04"
    ]
  },
  {
    name: 'allonePro',
    chName: 'Allone Pro',
    deviceType: connectDeviceType.ALL_ONE_PRO, //后台的设备号
    deviceGeneralType: 'controller_wifi', //前端定义的设备大类
    connectType: 'wifi',
    functionType: 'controller', //功能类型：控制器
    isHaveDeviceBelow: true, //可以添加设备
    link: '/device/xiaofang', //对应设备首页，实质和小方一样
  },
  {
    name: 'S30c',
    chName: 'S30c智能插座',
    deviceType: connectDeviceType.S30c, //后台的设备号
    deviceGeneralType: 'controller_wifi', //前端定义的设备大类
    connectType: 'wifi',
    functionType: 'socket', //功能类型：插座
    model: [
      'f1c981894d54486183701adabeef1623',
      '62f1da0474434509923b2dc947a0f14c',
      'dc8e39cd133f4164bc0190c1120cb116'
    ], //用以区分插座类型
  },
  {
    name: 'S20c',
    chName: 'S20c智能插座',
    deviceType: connectDeviceType.S20c, //后台的设备号
    deviceGeneralType: 'controller_wifi', //前端定义的设备大类
    connectType: 'wifi',
    functionType: 'socket', //功能类型：插座
    model: [
      '56d124ba95474fc98aafdb830e933789',
      'a0ef6660986d466d8f21fef72e66bb7d'
    ],
  },
  {
    name: 'wifiLedStrip',
    chName: '智能幻彩灯带（WiFi版）',
    deviceType: connectDeviceType.WIFI_LED_STRIP, //后台的设备号
    deviceGeneralType: 'controller_wifi', //前端定义的设备大类
    connectType: 'wifi',
    functionType: 'light', //功能类型：灯
  },
  /*--------------------------- 红外遥控类 ---------------------------*/
  {
    name: 'tv',
    chName: '电视遥控器',
    deviceType: connectDeviceType.TV,
    deviceGeneralType: 'remote',
    functionType: 'remote', //功能类型：遥控
    link: '/device/tv',
    kookongDeviceType: kookongDeviceType.TV,
  },
  {
    name: 'air',
    chName: '空调遥控器',
    deviceType: connectDeviceType.AIR,
    deviceGeneralType: 'remote',
    functionType: 'remote', //功能类型：遥控
    link: '/device/air',
    kookongDeviceType: kookongDeviceType.AIR,
  },
  {
    name: 'tvBox',
    chName: '机顶盒遥控器',
    deviceType: connectDeviceType.TV_BOX,
    deviceGeneralType: 'remote',
    functionType: 'remote', //功能类型：遥控
    link: '/device/tvbox',
    kookongDeviceType: kookongDeviceType.TV_BOX,
  },
  {
    name: 'fan',
    chName: '风扇遥控器',
    deviceType: connectDeviceType.FAN,
    deviceGeneralType: 'remote',
    functionType: 'remote', //功能类型：遥控
    link: '/device/fan',
    kookongDeviceType: kookongDeviceType.FAN,
  },
  /*--------------------------- zigBee类 ---------------------------*/
  {
    name: 'zigbeeMini',
    chName: 'ZigBee Mini网关',
    deviceType: connectDeviceType.ZIGBEE_MINI,
    deviceGeneralType: 'controller_zigbee',
    connectType: 'zigbee',
    link: '/device/zigbeeMini',
    functionType: 'controller', //功能类型：控制器
  },
  {
    name: 'zigbeeCurtainMoto',
    chName: 'ZigBee窗帘电机',
    deviceType: connectDeviceType.ZIGBEE_CURTAIN_MOTO,
    deviceGeneralType: 'remote_zigbee',
    connectType: 'zigbee',
    functionType: 'curtain', //功能类型：窗帘
    link: '/device/zigbeeCurtainMoto',
  },
];

/*  找到正确的支持的设备信息
* @param {obj}data后台的单个设备信息
* */
export const findSupportConnectDevice = (data) => {
  let deviceInfoArr = supportConnectDevice.filter(item => data.deviceType === item.deviceType);
  let deviceInfo = {};
  //
  if (deviceInfoArr.length > 1) { //找到多个deviceType相同的话
    deviceInfoArr.forEach(item => {
      item.model.forEach(subItem => {
        if (data.model === subItem) { //找到model号码相同的
          deviceInfo = item;
        }
      });
    })
  } else {
    deviceInfo = deviceInfoArr[0];
  }
  return deviceInfo;
};



// WEBPACK FOOTER //
// ./src/utils/device/deviceConnect.js